export default __webpack_public_path__ + "static/media/a017-3.0cc915eb.svg";